import { atom } from 'recoil';

export const introPreviewState = atom<boolean>({
  key: 'introPreviewState',
  default: false,
});
